(function () {

  function initStickyCart(scope = document) {

    scope.querySelectorAll(".footer-sticky-cart-button").forEach((btn) => {

      // Prevent duplicate binding
      if (btn.dataset.initialized === "true") return;
      btn.dataset.initialized = "true";

      let clicked = false;

      btn.addEventListener("click", () => {

        // Mimic jQuery .one()
        if (clicked) return;
        clicked = true;

        setTimeout(() => {

          const drawerTrigger = document.querySelector(".cart-drawer");

          if (drawerTrigger) {
            drawerTrigger.click();
          } else {
            console.warn("Cart drawer trigger not found.");
          }

        }, 1500);

      });

    });

  }

  // =========================
  // INITIAL LOAD
  // =========================
  document.addEventListener("DOMContentLoaded", () => {
    initStickyCart(document);
  });

  // =========================
  // SHOPIFY EVENTS
  // =========================
  document.addEventListener("shopify:section:load", (e) => {
    initStickyCart(e.target);
  });

  // =========================
  // GLOBAL REINIT
  // =========================
  document.addEventListener("theme:reinit", (e) => {
    initStickyCart(e.detail?.scope || document);
  });

})();